'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpModalDropDown = require('./rpModalDropDown');

var _rpModalDropDown2 = _interopRequireDefault(_rpModalDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * jQuery modal dropdown plugin
 *
 * @param {string|object} params Object of options or plugin method to execute
 * @param {*} args Arguments for methods
 * @returns {Object}
 */
_jquery2.default.fn.rpModalDropDown = function (params, args) {
    this.each(function () {
        _jquery2.default.fn.rpModalDropDown.init(this, params, args);
    });

    return this;
};

/**
 * Function for plugin initialisation
 *
 * @param {HTMLElement} el Element to apply plugin to
 * @param {string|object} params Object of options or plugin method to execute
 * @param {*} args Arguments for methods
 */
_jquery2.default.fn.rpModalDropDown.init = function (el, params, args) {
    var key = _rpModalDropDown2.default.pluginName;
    var object = _jquery2.default.data(el, key);
    if (!object) {
        _jquery2.default.data(el, key, new _rpModalDropDown2.default(el, params));
    } else if (params && params[0] !== '_' && object[params]) {
        object[params].call(object, args);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-jquery-modal-dropdown/lib/index.js
// module id = 1960
// module chunks = 0